import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AccountComponent} from './account.component';
import { AddressTableComponent } from './address-table/address-table.component';

@NgModule({
  declarations: [AccountComponent, AddressTableComponent],
  imports: [
    CommonModule
  ]
})
export class AccountModule { }
